import { render } from "./NotFound.vue?vue&type=template&id=184b04d9"
const script = {}

import exportComponent from "/var/www/Vakifbank-Vue-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__